export class OnDemandHome extends DrupalBehavior {
  onContent(context) {
    const form = context.querySelector('.rush-care-finder-form');
    if (form) {
      /*nakedFormSelect('select#edit-symptom', {
        context: {
          value: context,
        },
        keywordSearch: {
          on: true,
          placeholder: 'What’s wrong?'
        }
      });*/

      $('select#edit-symptom', context).selectpicker();

      /*const keywordSearch = context.querySelector('.rush-care-finder-form .keyword-search-wrap input');
      const keywordResults = context.querySelector('.rush-care-finder-form ul');
      let noResults = document.createElement('li');
      noResults.textContent = "No Results";
      noResults.classList.add('no-results');
      noResults.classList.add('hidden');
      keywordResults.appendChild(noResults);
      keywordSearch.addEventListener('keyup', function(e) {
        if (e.target.value !== '') {
          keywordResults.style.display = 'block';

          const matches = context.querySelectorAll('.rush-care-finder-form .options-wrap ul .match');
          if (matches.length < 1) {
            noResults.classList.remove('hidden');
          } else {
            noResults.classList.add('hidden');
          }
        } else {
          keywordResults.style.display = 'none';
        }
        if (e.keyCode === 13) {
          form.submit();
        }
      })*/

      const select = context.querySelector('select#edit-symptom');
      select.addEventListener('change', function (e) {
        form.submit();
      });
    }
  }
}
DrupalBehavior.register('rush_theme.pages', 'od_home', OnDemandHome);
